import { createContext } from 'react';
import { QUERY_KEYS_VEHICLES, useChartsData } from '../../../../Common/hooks/useChartsData';
import { useSecurityFiltersContext } from '../../../Common/Filters/hooks/useSecurityFiltersContext';

export const SpotsChartsDataContext = createContext();

const SpotsChartsDataProvider = ({ children }) => {
    const { filters } = useSecurityFiltersContext();
    const currentYear = new Date().getFullYear();
    const filterParams = {
            year: filters.year?.value || '',
            month: filters.month?.value ? String(Number(filters.month?.value)) : "",
            location: filters.unidade.value,
            city: filters.cidade?.value,
    }

    const { data, isLoading, isError } = useChartsData(
        {
            key: QUERY_KEYS_VEHICLES.VEHICLES_SPOTS,
            url: 'governanceroom/securitydashboard/vehicles/spots'
        },
        filterParams
    );

    const chartData = {
              spots: data || []
    }

    return (
        <SpotsChartsDataContext.Provider
            value={{
                chartData,
                isLoading,
                isError,
                filters,
                data
            }}
        >
            {children}
        </SpotsChartsDataContext.Provider>
    );
};

export default SpotsChartsDataProvider;
